<template>
  <div class="date-picker-custom" :class="{ 'disabled': disabled }">
    <div v-if="label" class="picker-label">
      {{ label }}:
    </div>
    <b-form-datepicker
      locale="en"
      :value="internal.value"
      @input="handleInput"
      :disabled="disabled"
      :hide-header="true"
      :date-format-options="dateFormatOptions" />
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'date-picker-custom',

  props: {
    value: {
      type: String,
      default: () => moment().format('YYYY-MM-DD'),
    },

    label: {
      type: String,
      default: null,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internal: {
        value: this.value,
      },
    };
  },
  methods: {
    handleInput(value) {
      this.internal.value = value;
      this.$emit('input', this.internal.value);
    },
  },

  computed: {
    dateFormatOptions() {
      return {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      };
    },
  },

  watch: {
    value(value) {
      if(this.internal.value !== value) {
        this.internal.value = value;
      }
    },
  },
}
</script>

<style scoped lang="scss">

</style>
